<template>
  <div class="bottom-fixed-btn" v-if="data">
    <button
      :style="{
        background: `center / cover no-repeat url('${data.buttonImage}')`
      }"
    >
      <!-- 我也要邀请 -->
    </button>
  </div>
</template>

<script>
export default {
  props: ['data']
};
</script>

<style lang="less" scoped>
.bottom-fixed-btn {
  width: 750px;
  position: fixed;
  bottom: 0px;
  left: 50%;
  transform: translate(-50%, 0);
  height: 160px;
  background: #ffffff;
  padding-bottom: 0; //适配iPhoneX
  padding-bottom: constant(safe-area-inset-bottom); //适配iPhoneX
  padding-bottom: env(safe-area-inset-bottom); //适配iPhoneX
  border-radius: 32px 32px 0px 0px;
  .fc;
  button {
    width: 623px;
    height: 106px;
    background: #ff6816;
    color: #ffffff;
    font-size: 42px;
    border-radius: 20px;
  }
}
</style>
